import { EntityName } from '@/shared/enums/EntityName';
import * as Designs from '@pkg/entities/designs';

const useCreateScenario = ({ designId, entity, scope }) => {
  const createScenario = Designs.mutations.useCreateScenario();

  const create = async ({ scenarioName, scenarioGoal, originScenario }) => {
    const entityType = originScenario?.type || entity?.__type;
    const updatedDesignId = originScenario?.designId || designId;
    const updatedScope = originScenario?.type || scope;
    const entityId = originScenario?.uuid || entity.uuid;
    const title = originScenario?.name ?? entity.title ?? entity.name;

    const updatedEntity = entity || {
      uuid: entityId,
      title,
    };

    const from = {
      design_uuid: updatedDesignId,
      entity_uuid: updatedEntity.uuid,
    };

    const entityName = EntityName[entityType]?.toLowerCase();

    const name = scenarioName ?? `${title} ${entityName} scenario`;
    const goal = scenarioGoal ?? '';

    const scenario = await createScenario({
      name,
      goal,
      scope: updatedScope,
      from,
    });
    if (!scenario) return null;

    return {
      entity: updatedEntity,
      scenarioId: scenario?.uuid,
      designId: updatedDesignId,
      scope: updatedScope,
    };
  };

  return {
    create,
  };
};

export default useCreateScenario;
